import { Typography, Button, Row, Col }  from 'antd'
import Breakpoint from '../../enums/breakpoint.enum.js'
import LatestPosts from '../latestPosts/latestPosts.component.js'
import useWidth from '../../hooks/useWidth.hook.js'


const { Text, Paragraph } = Typography

export const CgmConfirm = () => {
  const width = useWidth()

  const instructions = [{
    sections: [
      {
      title: 'Receive the Abbott FreeStyle Libre 3',
      description: <>The FreeStyle Libre Continuous Glucose Monitoring (CGM) system includes a small, discreet sensor designed to continuously monitor your glucose levels.</>
    }, 
  ]}, 
  {
    sections: [{
      title: 'Wear Freestyle Libre 3',
      description: <>Attach the sensor to the back of your upper arm. It remains securely in place for up to 14 days and is water-resistant, so you can swim, shower, and exercise without interruption.</>
    }]
  }, 
  {
    sections: [{
      title: 'Track your glucose levels',
      description: <>Use your mobile device to see how different foods, exercise routines, and sleep patterns impact your glucose levels, helping you make informed lifestyle choices.</>
    }]
  }]

  return (
    <div className="prescription-approval">


      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

      <Button
        className="question-btn"
        onClick={() => window.FrontChat("show")}
      >
        I have a question?
      </Button>

      <LatestPosts />
    </div>
  )
}

